module.exports = __webpack_public_path__ + "static/media/connect.c6480bea.svg";